import { render, staticRenderFns } from "./redeemhouse.vue?vue&type=template&id=49bc5a75&scoped=true&"
import script from "./redeemhouse.vue?vue&type=script&lang=js&"
export * from "./redeemhouse.vue?vue&type=script&lang=js&"
import style0 from "./redeemhouse.vue?vue&type=style&index=0&id=49bc5a75&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bc5a75",
  null
  
)

export default component.exports